var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "option-card",
    class: {
      selected: _vm.selected,
      pulse: _vm.selected,
      disabled: _vm.disabled,
      unavailable: _vm.unavailable
    },
    on: {
      "click": _vm.handleClick
    }
  }, [_vm.icon ? _c('div', {
    staticClass: "option-icon",
    style: {
      color: _vm.color
    }
  }, [_vm.isImageUrl(_vm.icon) ? _c('img', {
    staticClass: "icon-image",
    attrs: {
      "src": _vm.icon,
      "alt": ""
    }
  }) : _c('span', [_vm._v(_vm._s(_vm.icon))])]) : _vm._e(), _c('div', {
    staticClass: "option-text"
  }, [_vm._v(_vm._s(_vm.label))]), _vm.description ? _c('div', {
    staticClass: "option-description"
  }, [_vm._v(_vm._s(_vm.description))]) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }